export default __webpack_public_path__ + "static/media/wi_03d_scattered_clouds.f24c33c4.svg";